module.exports = __webpack_public_path__ + "img/footer.e7ec6595.jpg";